export const environment = {
  production: false,
  webUrl: 'https://uat.bizpay.co.in',
  postPaymentSuccessUrl: 'https://uat.bizpay.co.in/dashboard/admin-dashboard',
  apiUrl: 'https://uat.bizpay.co.in/rest/v1/',
  type: 'uat',
  policyPerInstance: '5',
  vgs: 'https://js.verygoodvault.com/vgs-show/1.5/ACiWvWF9tYAez4BitGpSE68f.js',
  vault_id: 'tntbuyt0v9u',
  mslConfig: {
    clientId: '89300111-f4eb-4918-9a66-59620791b9d1',
    redirectUri: 'https://uat.bizpay.co.in/auth/callback', // change redirect url based on where u want to redirect after the authentication
    postLogoutRedirectUri:'http://localhost:4200/login',
    authority: 'https://login.microsoftonline.com/organizations',
  },
  drfBackendBaseUrl: 'https://uat.bizpay.co.in/rest/v1/aad-exchange/',
  defaultPassword: 'Pass@123',
  branchKey: 'key_live_jEfCOP0t7dwyVNtXJ56KeaadDCbckxNB',
};
